<script setup lang="ts"></script>
<template>
  <footer class="bg-gray-100 border-t border-gray-400">
    <div class="mx-auto container px-2 sm:px-6 lg:px-8">
      <!-- <div class="max-w-5xl mx-auto py-4"> -->
      <div class="text-center py-4">
        <div class="text-sm text-gray-600">
          <p>
            DPT #8022, 2640 White Oak Cir Suite C, Aurora, IL 60502
            <span class="mx-2">|</span>
            877-477-8787
            <span class="mx-2">|</span>
            <a
              href="mailto:support@capsim.com"
              class="text-blue-700 hover:text-blue-800 underline underline-offset-2 decoration-1"
            >
              support@capsim.com</a
            >
          </p>
          <p class="mt-1">
            &copy; Capsim Management Simulations, Inc. {{ new Date().getFullYear() }}. All Rights
            Reserved.
            <span class="mx-2">|</span>
            Capsim® and Capsim.com®.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped></style>
